var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compact-banner",class:_vm.cssClass,style:(_vm.gradientStyle)},[(_vm.showComplexBackground)?_c('complex-background-big',{attrs:{"include-left-blobs":true}}):_vm._e(),(_vm.gridColor)?_c('banner-grid-overlay',{attrs:{"grid-color":_vm.gridColor}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }